module.exports = __webpack_public_path__ + "img/horizontal_6_5_pp3_8019.61396e02.png";